// extracted by mini-css-extract-plugin
module.exports = {"container":"ReviewContent_container__3JCqy"};